export const diaryTranslations = {
  lv: {
    title: 'Dienasgrāmata',
    description:
      'Katrs ieraksts ir viena diena un viens plāna punkts. Ja dienā strādāji pie diviem punktiem — izveido divus ierakstus.',
    pill_zero: '{{count}} ierakstu · {{hours}} h',
    pill_one: '{{count}} ieraksts · {{hours}} h',
    pill_other: '{{count}} ieraksti · {{hours}} h',
    calendar: 'Kalendārs',
    pdf: 'PDF',
    empty: 'Nav neviena ieraksta',
    emptyFiltered: 'Šajā atlasē ierakstu nav',
    noGradeRequired: 'Vērtējums nav nepieciešams',
    waiting: 'Gaida vērtējumu',
    credited: 'Ieskaitīts',
    notCredited: 'Neieskaitīts',
    textGrade: 'Teksta vērtējums',
    workplace: {
      OnSite: 'Klātienē',
      Remote: 'Attālināti',
      Mixed: 'Jaukts',
      Dynamic: 'Dinamisks',
      NotSet: 'Nav norādīta',
    },
    columns: {
      date: 'Datums',
      programitem: 'Plāna punkts',
      workplace: 'Darba vieta',
      time: 'Laiks',
      academichours: 'Akad. st.',
      duration: 'Ilgums',
      grade: 'Atzīme',
      commentintern: 'Mans komentārs',
      commentedusupervisor: 'Izglītības iestādes komentārs',
      commentsupervisor: 'Prakses vietas komentārs',
      actions: 'Darbības',
    },
    grades: {
      waiting: 'Gaida',
      credited: 'C',
      notCredited: 'NC',
      text: 'T',
    },
    filters: {
      button: 'Filtri',
      title: 'Filtrēt ierakstus',
      dateFrom: 'Datums no',
      dateTo: 'Datums līdz',
      programItem: 'Plāna punkts',
      allProgramItems: 'Visi punkti',
      workplace: 'Darba vieta',
      allWorkplaces: 'Visas',
      showOnly: 'Rādīt tikai',
      graded: 'Novērtētos',
      ungraded: 'Nenovērtētos',
      apply: 'Filtrēt',
      clear: 'Notīrīt',
      active: 'Aktīvie filtri',
      remove: 'Noņemt filtru “{{filter}}”',
    },
    actions: {
      menu: 'Darbības: {{date}}',
      edit: 'Labot',
      delete: 'Dzēst',
      deleteConfirm: 'Dzēst ierakstu par {{date}}?',
      deleted: 'Ieraksts dzēsts',
      deleteError: 'Neizdevās dzēst ierakstu',
      locked: 'Novērtēts — vairs nav rediģējams',
    },
    rules: {
      button: 'Pamācības un noteikumi',
      title: 'Noteikumi šajā praksē',
      academicHour: 'Akadēmiskā stunda',
      openDays: 'Cik ilgi diena ir atvērta',
      weekLimit: 'Limits nedēļā',
      multiple: 'Vairāki ieraksti dienā',
      grader: 'Kurš liek atzīmes',
      editing: 'Labošana un dzēšana',
      minutes_zero: '{{count}} minūšu',
      minutes_one: '{{count}} minūte',
      minutes_other: '{{count}} minūtes',
      noOpenDays: 'Vairs nav atvērtu dienu',
      weekLimitValue: '{{limit}} h · šonedēļ atlikušas {{left}} h',
      noWeekLimit: 'Nav nedēļas limita',
      multipleValue: 'Atļauts — pa vienam katram plāna punktam',
      graderValue: 'Katram punktam savs — skatīt programmā',
      editingValue: 'Līdz brīdim, kad ieraksts novērtēts',
      loading: 'Ielādē noteikumus',
      loadError: 'Neizdevās ielādēt noteikumus',
    },
    tiles: {
      week: 'Šonedēļ ierakstīts',
      weekLimit: 'No {{limit}} h limita — atlikušas {{left}} h',
      noWeekLimit: 'Nav nedēļas limita',
      days: 'Var aizpildīt dienas',
      daysCount_zero: '{{count}} dienu',
      daysCount_one: '{{count}} diena',
      daysCount_other: '{{count}} dienas',
      noOpenDays: 'Vairs nav atvērtu dienu',
      academicHour: 'Akadēmiskā stunda',
      academicHourHelp: 'Sistēma pārrēķina automātiski',
      graded: 'Novērtēti',
      awaiting: '{{value}} gaida vērtējumu',
      allGraded: 'Viss novērtēts',
      hours: '{{value}} h',
      minutes: '{{value}} min',
    },
  },
  en: {
    title: 'Diary',
    description:
      'Each record is one day and one plan item. If you worked on two items in a day, create two records.',
    pill_one: '{{count}} record · {{hours}} h',
    pill_other: '{{count}} records · {{hours}} h',
    calendar: 'Calendar',
    pdf: 'PDF',
    empty: 'No records yet',
    emptyFiltered: 'No matching records',
    noGradeRequired: 'No grade required',
    waiting: 'Awaiting grade',
    credited: 'Credited',
    notCredited: 'Not credited',
    textGrade: 'Text grade',
    workplace: {
      OnSite: 'On site',
      Remote: 'Remote',
      Mixed: 'Mixed',
      Dynamic: 'Dynamic',
      NotSet: 'Not specified',
    },
    columns: {
      date: 'Date',
      programitem: 'Plan item',
      workplace: 'Workplace',
      time: 'Time',
      academichours: 'Acad. h',
      duration: 'Duration',
      grade: 'Grade',
      commentintern: 'My comment',
      commentedusupervisor: 'Educational institution comment',
      commentsupervisor: 'Internship place comment',
      actions: 'Actions',
    },
    grades: {
      waiting: 'Waiting',
      credited: 'C',
      notCredited: 'NC',
      text: 'T',
    },
    filters: {
      button: 'Filters',
      title: 'Filter records',
      dateFrom: 'Date from',
      dateTo: 'Date to',
      programItem: 'Plan item',
      allProgramItems: 'All items',
      workplace: 'Workplace',
      allWorkplaces: 'All',
      showOnly: 'Show only',
      graded: 'Graded',
      ungraded: 'Not graded',
      apply: 'Filter',
      clear: 'Clear',
      active: 'Active filters',
      remove: 'Remove filter “{{filter}}”',
    },
    actions: {
      menu: 'Actions: {{date}}',
      edit: 'Edit',
      delete: 'Delete',
      deleteConfirm: 'Delete the record for {{date}}?',
      deleted: 'Record deleted',
      deleteError: 'Could not delete the record',
      locked: 'Graded — can no longer be edited',
    },
    rules: {
      button: 'Guides and rules',
      title: 'Rules in this internship',
      academicHour: 'Academic hour',
      openDays: 'How long a day stays open',
      weekLimit: 'Weekly limit',
      multiple: 'Several records per day',
      grader: 'Who grades',
      editing: 'Editing and deleting',
      minutes_one: '{{count}} minute',
      minutes_other: '{{count}} minutes',
      noOpenDays: 'No open days left',
      weekLimitValue: '{{limit}} h · {{left}} h left this week',
      noWeekLimit: 'No weekly limit',
      multipleValue: 'Allowed — one per plan item',
      graderValue: 'Set per item — see the program',
      editingValue: 'Until the record is graded',
      loading: 'Loading the rules',
      loadError: 'Could not load the rules',
    },
    tiles: {
      week: 'Recorded this week',
      weekLimit: 'Of the {{limit}} h limit — {{left}} h left',
      noWeekLimit: 'No weekly limit',
      days: 'Days open for entry',
      daysCount_one: '{{count}} day',
      daysCount_other: '{{count}} days',
      noOpenDays: 'No open days left',
      academicHour: 'Academic hour',
      academicHourHelp: 'Recalculated by the system',
      graded: 'Graded',
      awaiting: '{{value}} awaiting a grade',
      allGraded: 'Everything graded',
      hours: '{{value}} h',
      minutes: '{{value}} min',
    },
  },
}
